<script context="module" lang="ts">
  export type Step = {
    index: number;
    icon: string;
    detail: string;
  };
</script>

<script lang="ts">
  import { type Readable } from "svelte/store";

  export let step: Step;
  export let steps_total: number;
  export let active: boolean = false;
  export let progress: Readable<number>;
</script>



<div class="step" class:active
  on:click
  on:keypress>
  {#if active && progress}
    <div class="timing" style:width={$progress * 100 + '%'}></div>
  {/if}
  <div class="instruction">
    <div class="detail">
      <!-- svelte-ignore a11y-missing-attribute -->
      <img src={step.icon} />
      <span>{step.index + 1}/{steps_total}</span>
    </div>
    <p>{step.detail}</p>
  </div>
  
</div>

<style>

  .timing {
    display: block;
    width: 0;
    height: 2px;
    transition: width .3s;
    background-color: salmon;
  }

  /* progress[value]::-webkit-progress-bar {
    background-color: transparent;
    transition: all 200s;
  }

  progress[value]::-webkit-progress-value {
    background-color: salmon;
  } */

  .instruction {
    display: flex;
    gap: var(--_p2);
    padding: var(--_p1) var(--_p2) var(--_p2);
    font-size: 16px;
  }

  .instruction .detail {
    flex-shrink: 0;
    text-align: center;
  }

  .instruction img {
    display: block;
    width: 32px;
    height: 32px;
  }

  .instruction p {
    margin-bottom: 0;
  }

  /* .step.active {
    position: relative;
    padding-left: calc(var(--_p2) - 4px);
    transform: scale(1.025);
    transform-origin: left;
    background: #fff;
    border-left: 4px solid salmon;
    box-shadow: var(--vgwv-shadow-down);
    z-index: 5;
  } */

</style>
